export const billingProfileHc = {
  datosFacturacion: {
    titulo: "Données de facturation",
    requeridos: "Les données de facturation sont obligatoires",
  },
  perfil: {
    swalTitle: "Consultez votre e-mail",
    swalText:
      "Pour poursuivre le changement de mot de passe, consultez votre boîte de réception et suivez les étapes",
    swalConfirm: "Continuer",
    errorInesperado: `Oups ! Une erreur inattendue s'est produite`,
  },
  facturacionCuenta: {
    editarInfo: "Modifier les informations",
    direccionLinea1: "Adresse ligne 1",
    direccionLinea2: "Adresse ligne 2 (facultatif)",
    cancelar: "Annuler",
    guardando: "Enregistrement...",
    guardarCambios: "Enregistrer les modifications",
    errorCargar: "Erreur lors du chargement des données de facturation",
    actualizadoOk: "Données mises à jour avec succès",
    errorActualizar: "Erreur lors de la mise à jour",
    errorActualizarDatos: "Erreur lors de la mise à jour des données",
  },
};
